(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-shelves"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lanes = [];
    var state = { cat: '__all', rars: [], lo: null, hi: null };

    /* ===== Bloxcart-style inline quantity stepper for [data-bxc-add] cards.
       Replaces the old "click -> spinner -> checkmark -> revert to Add"
       flow (which showed nothing for the length of a full network
       round-trip) with an instant optimistic swap to minus/qty/plus,
       matching the pattern already proven for the hero carousel. This
       store re-issues a fresh cart line key on every cart write, so the key
       is always re-read from the latest response rather than cached once. ===== */
    var bxcMinusSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14"/></svg>';
    var bxcPlusSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
    var bxcAddLabel = {};
    var bxcLineKey = {};
    var bxcPendingAdd = {};
    var bxcTimers = {};
    function bxcAddBtnHTML(vid, label) { return '<button type="button" class="bxc-card__add" data-bxc-add data-vid="' + vid + '"><span class="bxc-add-lbl">' + label + '</span><span class="bxc-add-spin" aria-hidden="true"><svg class="bxc-spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><circle cx="12" cy="12" r="9" stroke-opacity="0.25"/><path d="M21 12a9 9 0 0 0-9-9" stroke-linecap="round"/></svg></span></button>'; }
    function bxcQtyHTML(vid, qty) { return '<div class="bxc-qty" data-bxc-qty data-vid="' + vid + '"><button type="button" class="bxc-qty__btn bxc-qty__plus" data-bxc-plus aria-label="زيادة">' + bxcPlusSvg + '</button><span class="bxc-qty__n" data-bxc-n>' + qty + '</span><button type="button" class="bxc-qty__btn bxc-qty__minus" data-bxc-minus aria-label="إنقاص">' + bxcMinusSvg + '</button></div>'; }
    function bxcFrag(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstChild; }
    /* What the cart will really hold after this add. bxc-minqty.js clamps an add
       up to a per-variant minimum (exposed as __zzMinForKey) and doubles BOGO
       variants, which bxc-card.liquid marks with .bxc-card__bogo. Computing it
       up front means the stepper can show the true quantity instead of always
       "1", and lets the add go out as a single absolute-quantity write. */
    function bxcWantQty(vid, card) {
      var min = 0;
      try { min = (window.__zzMinForKey && window.__zzMinForKey(String(vid))) || 0; } catch (e) { min = 0; }
      var q = min > 1 ? min : 1;
      if (card && card.querySelector('.bxc-card__bogo')) q = q * 2;
      return q;
    }
    /* /cart/add.js returns only the line it just added, with no cart totals, so
       the floating cart had to chase it with a second /cart.js GET -- two serial
       round trips before the pill total and drawer could show the truth.
       /cart/update.js sets an absolute quantity and returns the FULL cart, so a
       single round trip updates everything, and zz-floating-cart commits that
       response directly instead of re-fetching. Called without `want` only as a
       fallback when a change is requested for a line whose key was lost. */
    function bxcStartLine(vid, want) {
      var updates = {};
      updates[vid] = want || 1;
      bxcBusyStart(vid);
      var p = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          bxcBusyEnd(vid);
          /* Rejected (a quantity cap returns 422). Re-read the real cart rather
             than leaving the optimistic number on screen until a reload. */
          if (!cart) { bxcSyncCartQty(); return null; }
          var item = cart.items && cart.items.filter(function (it) { return String(it.variant_id) === String(vid); }).pop();
          bxcLineKey[vid] = item ? item.key : null;
          bxcApplyCart(cart);
          return bxcLineKey[vid];
        })
        .catch(function () { bxcBusyEnd(vid); bxcSyncCartQty(); return null; });
      bxcPendingAdd[vid] = p;
      return p;
    }
    function bxcGetKey(vid) {
      if (bxcLineKey[vid]) return Promise.resolve(bxcLineKey[vid]);
      return bxcPendingAdd[vid] || bxcStartLine(vid);
    }
    function bxcSendChange(vid, qty) {
      return bxcGetKey(vid).then(function (key) {
        if (!key) return;
        bxcBusyStart(vid);
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            bxcBusyEnd(vid);
            /* Rejected (a quantity cap returns 422). Re-read the real cart so the
               stepper cannot keep showing a number the server never accepted. */
            if (!data) { bxcSyncCartQty(); return; }
            if (qty <= 0) { bxcLineKey[vid] = null; }
            else {
              var item = data.items && data.items.filter(function (it) { return String(it.variant_id) === String(vid); }).pop();
              bxcLineKey[vid] = item ? item.key : key;
              document.dispatchEvent(new CustomEvent('bxc:cart-updated'));
            }
            bxcApplyCart(data);
          })
          .catch(function () { bxcBusyEnd(vid); bxcSyncCartQty(); });
      });
    }
    function bxcDebounceChange(vid, qty) {
      if (bxcTimers[vid]) clearTimeout(bxcTimers[vid]);
      bxcTimers[vid] = setTimeout(function () { delete bxcTimers[vid]; bxcSendChange(vid, qty); }, 300);
    }
    function bxcImmediateChange(vid, qty) {
      if (bxcTimers[vid]) { clearTimeout(bxcTimers[vid]); delete bxcTimers[vid]; }
      return bxcSendChange(vid, qty);
    }
    /* Cart state changes in places this section does not own -- the floating cart
       drawer writes straight to /cart/change.js, and removing an item there used
       to leave the card stepper showing its old quantity until a reload.
       bxc-global.js re-broadcasts every cart mutation as `zz:cart`, and this
       reconciles the cards against it in BOTH directions: Add button -> stepper
       when a line appears, stepper -> Add button when the line is gone, and the
       number in between. Variants with a write of our own still in flight are
       skipped so this never fights the customer mid-tap. */
    var bxcBusy = {};
    function bxcBusyStart(vid) { bxcBusy[vid] = (bxcBusy[vid] || 0) + 1; }
    function bxcBusyEnd(vid) { bxcBusy[vid] = Math.max(0, (bxcBusy[vid] || 1) - 1); }
    function bxcApplyCart(cart) {
      if (!cart || !cart.items) return;
      var byVariant = {};
      cart.items.forEach(function (it) {
        var l = byVariant[it.variant_id];
        if (l) { l.quantity += it.quantity; } else { byVariant[it.variant_id] = { quantity: it.quantity, key: it.key }; }
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-bxc-add]'), function (btn) {
        var vid = btn.getAttribute('data-vid');
        if (!vid || bxcTimers[vid] || bxcBusy[vid]) return;
        var l = byVariant[vid];
        if (!l) return;
        var lbl = btn.querySelector('.bxc-add-lbl');
        bxcAddLabel[vid] = lbl ? lbl.innerHTML : btn.innerHTML;
        bxcLineKey[vid] = l.key;
        btn.replaceWith(bxcFrag(bxcQtyHTML(vid, l.quantity)));
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-bxc-qty]'), function (wrap) {
        var vid = wrap.getAttribute('data-vid');
        if (!vid || bxcTimers[vid] || bxcBusy[vid]) return;
        var l = byVariant[vid];
        if (l) {
          bxcLineKey[vid] = l.key;
          var n = wrap.querySelector('[data-bxc-n]');
          if (n && n.textContent !== String(l.quantity)) n.textContent = l.quantity;
        } else {
          bxcLineKey[vid] = null;
          wrap.replaceWith(bxcFrag(bxcAddBtnHTML(vid, bxcAddLabel[vid] || 'أضف')));
        }
      });
    }
    function bxcSyncCartQty() {
      if (!document.querySelector('[data-bxc-add], [data-bxc-qty]')) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(bxcApplyCart)
        .catch(function () {});
    }
    document.addEventListener('zz:cart', function (e) { if (e && e.detail) bxcApplyCart(e.detail); });

    function gridEl() { return document.getElementById('product-grid-container'); }
    function closeMenus() { document.querySelectorAll('[data-bxc-sortmenu], [data-bxc-switchmenu]').forEach(function (m) { m.hidden = true; }); }
    function openSide() { var s = document.querySelector('[data-bxc-side]'); var b = document.querySelector('[data-bxc-sidebackdrop]'); if (s) s.classList.add('is-open'); if (b) b.hidden = false; document.body.classList.add('bxc-noscroll'); }
    function closeSide() { var s = document.querySelector('[data-bxc-side]'); var b = document.querySelector('[data-bxc-sidebackdrop]'); if (s) s.classList.remove('is-open'); if (b) b.hidden = true; document.body.classList.remove('bxc-noscroll'); }
    function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
    function toggleFilter() { if (isMobile()) { openSide(); } else { var lay = document.querySelector('.bxc-layout'); if (lay) lay.classList.toggle('is-side-collapsed'); } }
    function scrollToTop() { var sec = document.querySelector('.bxc'); if (sec) window.scrollTo({ top: sec.offsetTop - 16, behavior: 'smooth' }); }

    /* Move viewport-fixed elements out of #MainContent onto <body>. A transformed
       ancestor (page transitions, animations) becomes the containing block for
       position:fixed and would pin the nav to the page instead of the screen. */
    function hoist(sel) {
      var els = Array.prototype.slice.call(document.querySelectorAll(sel));
      if (!els.length) return;
      var keep = null;
      els.forEach(function (el) { if (!el.hasAttribute('data-bxc-moved')) keep = el; });
      if (!keep) keep = els[0];
      els.forEach(function (el) { if (el !== keep && el.parentNode) el.parentNode.removeChild(el); });
      keep.setAttribute('data-bxc-moved', '1');
      if (keep.parentNode !== document.body) document.body.appendChild(keep);
    }

    function cardMatches(card) {
      if (state.rars.length) { var rar = card.getAttribute('data-rarity') || ''; if (state.rars.indexOf(rar) === -1) return false; }
      var price = parseFloat(card.getAttribute('data-price')) / 100;
      if (!isNaN(price)) { if (state.lo !== null && price < state.lo) return false; if (state.hi !== null && price > state.hi) return false; }
      return true;
    }

    /* ============ TWO-VIEW BUCKET RENDER: wipe first, then inject fresh ============ */
    function updateProductGrid() {
      var c = gridEl(); if (!c) return;
      c.innerHTML = '';
      var shown = 0;
      if (state.cat === '__all') {
        c.classList.remove('is-flat');
        lanes.forEach(function (L) {
          L.row.innerHTML = '';
          var vis = 0;
          L.cards.forEach(function (card) {
            if (cardMatches(card)) { card.style.display = ''; vis++; } else { card.style.display = 'none'; }
            L.row.appendChild(card);
          });
          L.el.style.display = vis ? '' : 'none';
          shown += vis;
          c.appendChild(L.el);
        });
      } else {
        c.classList.add('is-flat');
        lanes.forEach(function (L) {
          if (L.word !== state.cat) return;
          L.cards.forEach(function (card) {
            if (cardMatches(card)) { card.style.display = ''; c.appendChild(card); shown++; }
          });
        });
      }
      var empty = document.querySelector('[data-bxc-empty]'); if (empty) empty.classList.toggle('is-shown', shown === 0);
    }

    /* ============ UNIFIED CATEGORY FILTER — pills, bottom nav, and عرض الكل ============ */
    function filterCategory(categoryName) {
      state.cat = categoryName;
      document.querySelectorAll('[data-bxc-filter]').forEach(function (x) {
        var on = x.getAttribute('data-bxc-filter') === categoryName;
        if (x.classList.contains('bxc-shelf__all')) { x.classList.remove('is-active'); return; }
        x.classList.toggle('is-active', on);
        if (on) { var bar = x.closest('.bxc-catnav__inner, .bxc-bottomnav'); if (bar && bar.scrollTo) { bar.scrollTo({ left: x.offsetLeft - bar.clientWidth / 2 + x.clientWidth / 2, behavior: 'smooth' }); } }
      });
      updateProductGrid();
      closeSide();
      scrollToTop();
    }

    function initRange() {
      var wrap = document.querySelector('[data-bxc-range]'); if (!wrap || wrap.dataset.bound) return; wrap.dataset.bound = '1';
      var min = parseFloat(wrap.getAttribute('data-min')) || 0; var max = parseFloat(wrap.getAttribute('data-max')) || 0;
      var rmin = wrap.querySelector('[data-bxc-rmin]'); var rmax = wrap.querySelector('[data-bxc-rmax]'); var fill = wrap.querySelector('[data-bxc-fill]');
      var nmin = document.querySelector('[data-bxc-nmin]'); var nmax = document.querySelector('[data-bxc-nmax]');
      function clamp(val) { if (isNaN(val)) val = min; if (val < min) val = min; if (val > max) val = max; return val; }
      function upd() {
        var a = parseFloat(rmin.value); var b = parseFloat(rmax.value); if (a > b) { var t = a; a = b; b = t; }
        var span = (max - min) || 1; var p1 = ((a - min) / span) * 100; var p2 = ((b - min) / span) * 100;
        if (fill) { fill.style.left = p1 + '%'; fill.style.right = (100 - p2) + '%'; }
        if (nmin && document.activeElement !== nmin) nmin.value = Math.round(a);
        if (nmax && document.activeElement !== nmax) nmax.value = Math.round(b);
        state.lo = a; state.hi = b;
      }
      rmin.addEventListener('input', function () { if (parseFloat(rmin.value) > parseFloat(rmax.value)) rmin.value = rmax.value; upd(); updateProductGrid(); });
      rmax.addEventListener('input', function () { if (parseFloat(rmax.value) < parseFloat(rmin.value)) rmax.value = rmin.value; upd(); updateProductGrid(); });
      if (nmin) nmin.addEventListener('change', function () { var val = clamp(parseFloat(nmin.value)); if (val > parseFloat(rmax.value)) val = parseFloat(rmax.value); rmin.value = val; upd(); updateProductGrid(); });
      if (nmax) nmax.addEventListener('change', function () { var val = clamp(parseFloat(nmax.value)); if (val < parseFloat(rmin.value)) val = parseFloat(rmin.value); rmax.value = val; upd(); updateProductGrid(); });
      upd();
    }
    function resetFilters() {
      document.querySelectorAll('.bxc-rar.is-on').forEach(function (p) { p.classList.remove('is-on'); });
      state.rars = [];
      var wrap = document.querySelector('[data-bxc-range]');
      if (wrap) { var rmin = wrap.querySelector('[data-bxc-rmin]'); var rmax = wrap.querySelector('[data-bxc-rmax]'); rmin.value = rmin.min; rmax.value = rmax.max; rmin.dispatchEvent(new Event('input')); rmax.dispatchEvent(new Event('input')); }
      else { updateProductGrid(); }
    }
    function findCartIcon() { return document.querySelector('#cart-icon-bubble') || document.querySelector('a[href$="/cart"]') || document.querySelector('a[href*="/cart"]') || document.querySelector('[data-cart-icon]'); }
    function floatPlusOne() {
      var icon = findCartIcon(); var el = document.createElement('div'); el.className = 'bxc-plusone'; el.textContent = '+1'; document.body.appendChild(el);
      if (icon) { var r = icon.getBoundingClientRect(); el.style.left = (r.left + r.width / 2) + 'px'; el.style.top = (r.top + 4) + 'px'; } else { el.style.left = '50%'; el.style.top = '76px'; }
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-go'); }); });
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 900);
    }
    document.addEventListener('click', function (e) {
      var so = e.target.closest('[data-bxc-sortbtn]');
      if (so) { var m = so.parentNode.querySelector('[data-bxc-sortmenu]'); var was = m.hidden; closeMenus(); m.hidden = !was; e.stopPropagation(); return; }
      var sb = e.target.closest('[data-bxc-switchbtn]');
      if (sb) { var m2 = sb.parentNode.querySelector('[data-bxc-switchmenu]'); var was2 = m2.hidden; closeMenus(); m2.hidden = !was2; e.stopPropagation(); return; }
      if (e.target.closest('[data-bxc-toggle-filter]')) { toggleFilter(); closeMenus(); return; }
      if (e.target.closest('[data-bxc-closeside]')) { closeSide(); return; }
      if (e.target.closest('[data-bxc-resetfilters]')) { resetFilters(); return; }
      if (e.target.closest('[data-bxc-applyfilters]')) { closeSide(); return; }
      var gm = e.target.closest('[data-bxc-gamesmore]');
      if (gm) { var grid = document.querySelector('[data-bxc-games]'); var lbl = gm.querySelector('[data-bxc-gamesmore-lbl]'); if (grid) { grid.classList.toggle('is-collapsed'); gm.classList.toggle('is-open'); if (lbl) lbl.textContent = grid.classList.contains('is-collapsed') ? 'عرض أكثر' : 'عرض أقل'; } return; }
      var rp = e.target.closest('[data-bxc-rar]');
      if (rp) { rp.classList.toggle('is-on'); state.rars = []; document.querySelectorAll('.bxc-rar.is-on').forEach(function (p) { state.rars.push(p.getAttribute('data-bxc-rar')); }); updateProductGrid(); return; }
      var addBtn = e.target.closest('[data-bxc-add]');
      if (addBtn && !addBtn.disabled) {
        e.preventDefault(); var aid = addBtn.getAttribute('data-vid'); if (!aid) return;
        var awant = bxcWantQty(aid, addBtn.closest('.bxc-card'));
        var lbl0 = addBtn.querySelector('.bxc-add-lbl');
        bxcAddLabel[aid] = lbl0 ? lbl0.innerHTML : addBtn.innerHTML;
        addBtn.replaceWith(bxcFrag(bxcQtyHTML(aid, awant)));
        floatPlusOne();
        /* No parallel /cart.js kick here any more. Fired at click time it raced
           the write and could land first, committing a pre-add snapshot that
           visibly rolled the pill count backwards before correcting itself.
           The write below returns the whole cart, so there is nothing to chase. */
        bxcStartLine(aid, awant);
        return;
      }
      var plusBtn = e.target.closest('[data-bxc-plus]');
      if (plusBtn) {
        e.preventDefault();
        var wrap = plusBtn.closest('[data-bxc-qty]'); if (!wrap) return;
        var pvid = wrap.getAttribute('data-vid');
        var n = wrap.querySelector('[data-bxc-n]');
        var next = (parseInt(n.textContent, 10) || 1) + 1;
        n.textContent = next;
        floatPlusOne();
        bxcDebounceChange(pvid, next);
        return;
      }
      var minusBtn = e.target.closest('[data-bxc-minus]');
      if (minusBtn) {
        e.preventDefault();
        var wrap2 = minusBtn.closest('[data-bxc-qty]'); if (!wrap2) return;
        var tvid = wrap2.getAttribute('data-vid');
        var n2 = wrap2.querySelector('[data-bxc-n]');
        var cur = parseInt(n2.textContent, 10) || 1;
        if (cur > 1) {
          /* Step down. Debounced like the plus button, so a run of taps sends
             one request instead of one per tap. */
          n2.textContent = cur - 1;
          bxcDebounceChange(tvid, cur - 1);
        } else {
          /* Last one out: drop the line and restore the Add button. */
          wrap2.replaceWith(bxcFrag(bxcAddBtnHTML(tvid, bxcAddLabel[tvid] || 'أضف')));
          bxcImmediateChange(tvid, 0);
        }
        return;
      }
      var f = e.target.closest('[data-bxc-filter]');
      if (f) { e.preventDefault(); filterCategory(f.getAttribute('data-bxc-filter')); return; }
      var s = e.target.closest('[data-bxc-scroll]');
      if (s) { var scr = s.closest('.bxc-shelf__scroller'); var row = scr && scr.querySelector('[data-bxc-row]'); if (row) { var dir = parseInt(s.getAttribute('data-bxc-scroll'), 10) || 1; row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' }); } return; }
      if (!e.target.closest('[data-bxc-sortmenu], [data-bxc-switchmenu]')) closeMenus();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenus(); closeSide(); } });
    function init() {
      hoist('.bxc-bottomnav');
      hoist('[data-bxc-sidebackdrop]');
      initRange();
      var c = gridEl();
      if (c && !c.dataset.bound) {
        c.dataset.bound = '1';
        lanes = [];
        c.querySelectorAll('[data-bxc-shelf]').forEach(function (el) {
          var row = el.querySelector('[data-bxc-row]');
          if (!row) return;
          lanes.push({ el: el, word: el.getAttribute('data-bxc-shelf'), row: row, cards: Array.prototype.slice.call(row.children) });
        });
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bxcSyncCartQty); } else { bxcSyncCartQty(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  function activate(root, key){
    var pills = root.querySelectorAll('[data-dbs-tab]');
    var panels = root.querySelectorAll('[data-dbs-panel]');
    Array.prototype.forEach.call(pills, function(p){
      var on = p.getAttribute('data-dbs-tab') === key;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(panels, function(pn){
      pn.classList.toggle('is-active', pn.getAttribute('data-dbs-panel') === key);
    });
  }
  function init(root){
    var roots = (root || document).querySelectorAll('.dbs');
    Array.prototype.forEach.call(roots, function(s){
      if(s.dataset.dbsInit === '1') return; s.dataset.dbsInit = '1';
      var pills = s.querySelectorAll('[data-dbs-tab]');
      Array.prototype.forEach.call(pills, function(p){
        p.addEventListener('click', function(){ activate(s, p.getAttribute('data-dbs-tab')); });
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:block:select', function(e){
    var root = e.target.closest && e.target.closest('.dbs'); if(!root) return;
    var key = e.target.getAttribute && e.target.getAttribute('data-dbs-tab');
    if(!key){ var el = e.target.querySelector && e.target.querySelector('[data-dbs-tab]'); if(el) key = el.getAttribute('data-dbs-tab'); }
    if(key) activate(root, key);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farm-qty"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function parseMoney(str){
      if(!str){ return null; }
      var first = -1, last = -1, i, c;
      for(i = 0; i < str.length; i++){ c = str.charCodeAt(i); if(c >= 48 && c <= 57){ if(first < 0){ first = i; } last = i; } }
      if(first < 0){ return null; }
      var pre = str.slice(0, first);
      var suf = str.slice(last + 1);
      var mid = str.slice(first, last + 1);
      var hasDot = mid.indexOf('.') >= 0, hasComma = mid.indexOf(',') >= 0;
      var clean = '', dec = 0, seenDot = false, j, ch;
      for(j = 0; j < mid.length; j++){
        ch = mid.charAt(j);
        if(ch >= '0' && ch <= '9'){ clean += ch; if(seenDot){ dec++; } }
        else if(ch === '.'){ if(hasDot){ clean += '.'; seenDot = true; } }
        else if(ch === ','){ if(hasComma && !hasDot){ clean += '.'; seenDot = true; } }
      }
      var num = parseFloat(clean);
      if(isNaN(num)){ return null; }
      return { num: num, pre: pre, suf: suf, dec: dec };
    }
    function group(intStr){
      var out = '', c = 0, i;
      for(i = intStr.length - 1; i >= 0; i--){ out = intStr.charAt(i) + out; c++; if(c % 3 === 0 && i > 0){ out = ',' + out; } }
      return out;
    }
    function fmt(num, ref){
      var s = num.toFixed(ref.dec);
      var dot = s.indexOf('.');
      var ip = dot >= 0 ? s.slice(0, dot) : s;
      var fp = dot >= 0 ? s.slice(dot) : '';
      return ref.pre + group(ip) + fp + ref.suf;
    }
    function init(){
      var root = document.querySelector('[data-fqty]');
      if(!root){ return; }
      var info = document.querySelector('.bxp-info');
      if(info && root.parentNode !== info){
        var anchor = document.querySelector('.bxp-qty');
        if(anchor){ info.insertBefore(root, anchor); }
        else { var wa = info.querySelector('.bxp-wa'); if(wa){ info.insertBefore(root, wa); } else { info.appendChild(root); } }
      }
      var min = parseInt(root.getAttribute('data-min'), 10) || 1;
      var vid = root.getAttribute('data-vid');
      var input = root.querySelector('[data-fqty-input]');
      var totalEl = root.querySelector('[data-fqty-total]');
      var srcEl = root.querySelector('[data-fqty-unit]');
      var addBtn = root.querySelector('[data-fqty-add]');
      var qty = min;
      function unitText(){
        var n = document.querySelector('[data-bxp-now]');
        if(n){ var t = (n.textContent || '').trim(); if(t){ return t; } }
        if(srcEl){ return (srcEl.textContent || '').trim(); }
        return '';
      }
      function render(){
        if(input){ input.value = qty; }
        if(totalEl){
          var ref = parseMoney(unitText());
          if(ref){ totalEl.textContent = fmt(ref.num * qty, ref); }
        }
      }
      function setQty(n){ if(isNaN(n) || n < min){ n = min; } qty = Math.floor(n); render(); }
      root.addEventListener('click', function(e){
        if(e.target.closest('[data-fqty-minus]')){ setQty(qty - 1); }
        else if(e.target.closest('[data-fqty-plus]')){ setQty(qty + 1); }
        else if(e.target.closest('[data-fqty-buy]')){ go(true); }
        else if(e.target.closest('[data-fqty-add]')){ go(false); }
      });
      if(input){
        input.addEventListener('change', function(){ setQty(parseInt(input.value, 10)); });
        input.addEventListener('blur', function(){ setQty(parseInt(input.value, 10)); });
      }
      function go(checkout){
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] }) })
        .then(function(r){ if(!r.ok){ throw new Error('add'); } return r.json(); })
        .then(function(){ if(checkout){ window.location.href = '/checkout'; } else { if(addBtn){ addBtn.classList.add('is-done'); setTimeout(function(){ addBtn.classList.remove('is-done'); }, 1200); } document.dispatchEvent(new CustomEvent('bxc:cart-updated')); } })
        .catch(function(){});
      }
      var watch = document.querySelector('[data-bxp-now]') || srcEl;
      if(watch && typeof MutationObserver !== 'undefined'){
        var mo = new MutationObserver(function(){ render(); });
        mo.observe(watch, { childList: true, subtree: true, characterData: true });
      }
      render();
      setTimeout(render, 400);
      setTimeout(render, 1200);
    }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();
  (function(){
    function initBogo(){
      var b = document.querySelector('[data-bxgo]');
      if(!b){ return; }
      var info = document.querySelector('.bxp-info');
      if(info && b.parentNode !== info){
        var anchor = document.querySelector('.bxp-qty') || document.querySelector('.bxp-ctas');
        if(anchor){ info.insertBefore(b, anchor); } else { info.appendChild(b); }
      }
    }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initBogo); } else { initBogo(); }
    document.addEventListener('shopify:section:load', initBogo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-receive"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var sections=(root||document).querySelectorAll('.zilzal-htr');
    Array.prototype.forEach.call(sections,function(s){
      if(s.dataset.htrInit==='1') return; s.dataset.htrInit='1';
      var cards=s.querySelectorAll('.zilzal-htr__card');
      if(!cards.length) return;
      var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      if(reduce || !('IntersectionObserver' in window)) return;
      s.classList.add('htr-anim');
      var io=new IntersectionObserver(function(en){en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });},{threshold:0.15});
      Array.prototype.forEach.call(cards,function(c,i){ c.style.transitionDelay=(i*0.09)+'s'; io.observe(c); });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-blocks"] && !Shopify.designMode) return;
  try {
    
(function(){
  function openModal(m){ m.classList.add('is-open'); m.setAttribute('aria-hidden','false'); document.body.classList.add('zh-noscroll'); }
  function closeModal(m){ m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); document.body.classList.remove('zh-noscroll'); }
  function bindModal(m){
    var overlay=m.querySelector('[data-zh-modal-overlay]');
    var panel=m.querySelector('[data-zh-modal-panel]');
    var closeBtn=m.querySelector('[data-zh-modal-close]');
    if(overlay) overlay.addEventListener('click',function(){ closeModal(m); });
    if(closeBtn) closeBtn.addEventListener('click',function(){ closeModal(m); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && m.classList.contains('is-open')) closeModal(m); });
    if(panel){
      var sy=0, touching=false, atTop=true;
      panel.addEventListener('touchstart',function(e){ touching=true; sy=e.touches[0].clientY; atTop=(panel.scrollTop<=0); panel.style.transition='none'; },{passive:true});
      panel.addEventListener('touchmove',function(e){ if(!touching||!atTop) return; var dy=e.touches[0].clientY-sy; if(dy>0) panel.style.transform='translateY('+dy+'px)'; },{passive:true});
      panel.addEventListener('touchend',function(e){ if(!touching) return; touching=false; panel.style.transition=''; var dy=e.changedTouches[0].clientY-sy; panel.style.transform=''; if(atTop && dy>100) closeModal(m); },{passive:true});
    }
  }
  function initModals(root){
    var modals=(root||document).querySelectorAll('.zilzal-hero-wrapper [data-zh-modal]');
    Array.prototype.forEach.call(modals,function(modal){
      var sid=modal.getAttribute('data-zh-sid');
      var stale=document.querySelectorAll('body > [data-zh-modal][data-zh-sid="'+sid+'"]');
      Array.prototype.forEach.call(stale,function(x){ if(x!==modal && x.parentNode) x.parentNode.removeChild(x); });
      if(modal.parentNode!==document.body){ document.body.appendChild(modal); }
      if(modal.dataset.zhBound!=='1'){ modal.dataset.zhBound='1'; bindModal(modal); }
    });
    var triggers=(root||document).querySelectorAll('[data-zh-open-modal]');
    Array.prototype.forEach.call(triggers,function(t){
      if(t.dataset.zhBound==='1') return; t.dataset.zhBound='1';
      t.addEventListener('click',function(e){ e.preventDefault(); var sid=t.getAttribute('data-zh-target'); var m=document.querySelector('[data-zh-modal][data-zh-sid="'+sid+'"]'); if(m) openModal(m); });
    });
  }
  function init(){ initModals(document); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bxc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var VD = [];
    var qty = 1;
    function hoist(sel) {
      var els = Array.prototype.slice.call(document.querySelectorAll(sel));
      if (!els.length) return;
      var keep = null;
      els.forEach(function (el) { if (!el.hasAttribute('data-bxp-moved')) keep = el; });
      if (!keep) keep = els[0];
      els.forEach(function (el) { if (el !== keep && el.parentNode) el.parentNode.removeChild(el); });
      keep.setAttribute('data-bxp-moved', '1');
      if (keep.parentNode !== document.body) document.body.appendChild(keep);
    }
    function readVariants() {
      var el = document.querySelector('[data-bxp-vdata]');
      if (!el) return;
      try { VD = JSON.parse(el.textContent); } catch (e) { VD = []; }
    }
    function setQty(n) {
      qty = n < 1 ? 1 : n;
      document.querySelectorAll('[data-bxp-qval]').forEach(function (x) { x.textContent = qty; });
    }
    function applyVariant(vid) {
      var d = null;
      VD.forEach(function (x) { if (String(x.id) === String(vid)) d = x; });
      if (!d) return;
      document.querySelectorAll('[data-bxp-now]').forEach(function (n) { n.textContent = d.n; });
      document.querySelectorAll('[data-bxp-was]').forEach(function (w) { if (d.w) { w.textContent = d.w; w.hidden = false; } else { w.hidden = true; } });
      document.querySelectorAll('[data-bxp-disc]').forEach(function (p) { if (d.p > 0) { p.textContent = d.p + '% خصم'; p.hidden = false; } else { p.hidden = true; } });
      document.querySelectorAll('[data-bxp-add], [data-bxp-buynow]').forEach(function (b) { b.setAttribute('data-vid', d.id); b.disabled = !d.a; b.classList.toggle('is-disabled', !d.a); });
    }
    function postAdd(vid) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    }
    document.addEventListener('click', function (e) {
      var qm = e.target.closest('[data-bxp-qminus]');
      if (qm) { setQty(qty - 1); return; }
      var qp = e.target.closest('[data-bxp-qplus]');
      if (qp) { setQty(qty + 1); return; }
      var t = e.target.closest('[data-bxp-thumb]');
      if (t) { var main = document.querySelector('[data-bxp-main]'); if (main) main.src = t.getAttribute('data-src'); document.querySelectorAll('[data-bxp-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); }); return; }
      var a = e.target.closest('[data-bxp-add]');
      if (a && !a.disabled) {
        if (a.classList.contains('is-loading') || a.classList.contains('is-done')) return;
        var avid = a.getAttribute('data-vid'); if (!avid) return;
        a.classList.add('is-loading');
        postAdd(avid).then(function () {
          a.classList.remove('is-loading'); a.classList.add('is-done');
          setTimeout(function () { a.classList.remove('is-done'); }, 1200);
          document.dispatchEvent(new CustomEvent('bxc:cart-updated'));
        }).catch(function () { a.classList.remove('is-loading'); });
        return;
      }
      var bn = e.target.closest('[data-bxp-buynow]');
      if (bn && !bn.disabled) {
        if (bn.classList.contains('is-loading')) return;
        var bvid = bn.getAttribute('data-vid'); if (!bvid) return;
        bn.classList.add('is-loading');
        postAdd(bvid).then(function () { window.location.href = '/checkout'; }).catch(function () { bn.classList.remove('is-loading'); });
        return;
      }
    });
    document.addEventListener('change', function (e) {
      var s = e.target.closest('[data-bxp-variant]');
      if (s) applyVariant(s.value);
    });
    function init() { readVariants(); setQty(1); hoist('[data-bxp-stickybar]'); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
